import type { TPlayerRegistrationResponse } from '@lucimark/shared/database/players-directory-schema'

let inFlight: Promise<TPlayerRegistrationResponse> | null = null

/**
 * Coalesces concurrent GET /registration calls while unregistered (bootstrap, WS connect, and the
 * periodic refetch from `scheduleRegistrationRefetch` — see `PAIRING_REGISTRATION_REFETCH_INTERVAL_MS`
 * in `@/constants`). One network round-trip satisfies every awaiter.
 */
export function fetchPairingRegistrationWithDedupe(
  runFetch: () => Promise<TPlayerRegistrationResponse>
): Promise<TPlayerRegistrationResponse> {
  if (inFlight !== null) {
    return inFlight
  }
  inFlight = (async () => {
    try {
      return await runFetch()
    }
    finally {
      inFlight = null
    }
  })()
  return inFlight
}
